function Loader() {
    return (
        <svg className="w-36 h-36" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" r="30" stroke="#472977" stroke-width="10" fill="none"></circle>
            <circle cx="50" cy="50" r="30" stroke="#ff4f58" stroke-width="10" stroke-linecap="square" fill="none">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="2s" values="0 50 50;180 50 50;720 50 50" keyTimes="0;0.5;1"></animateTransform>
                <animate attributeName="stroke-dasharray" repeatCount="indefinite" dur="2s" values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882" keyTimes="0;0.5;1"></animate>
            </circle>
        </svg>
    );
}

// bg-[#FFFFFF]/80 

export default Loader;